import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/frontend/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/frontend/markdoc/tags.js'
import * as nodes from '/vercel/path0/frontend/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Jak katalogować książki?\ndescription: Każda biblioteczka w naszym domu powinna mieć katalog - wiele na tym zyskujemy. Jak go zrobić?\n---\n\nKatalogowanie pozwala na stworzenie systemu śledzenia pozycji. Może to być umożliwienie śledzenia pojedynczej osobie swojego zbioru, lub grupom osób wspólnego zbioru. Opcja pierwsza może być dobrowolna i w dowolnej chwili rozszerzyć się na opcję drugą.\n\nOpcja druga tyczy się sytuacji, kiedy mamy Asię i Basię z których każda ma po 10 książek. Razem mają 20 a dzięki ich skatalogowaniu będą wiedzieć gdzie i u kogo każda jest.\n\n---\n\n## System Katalogowania\n\nCechy systemu do katalogowania są nastepujące:\n\n- **identyfikacja** – jeden identyfikator może zwrócić informację z wielu miejsc w internecie.\n- **współdziałanie** – wiele półek może współpracować ze sobą w celu wymiany i wyszukania pozycji.\n- **trwałość** – identyfikator po przydzieleniu go do dokumentu nigdy się nie zmieni (naklejona etykieta).\n- **wyjątkowość** – jeden identyfikator przypisany jest do jednego dokumentu (w naszym wypadku jest to książka).\n\n___\n\n## Katalogowanie jednoosobowe\n\nChcę wyłącznie mieć listę swoich książek. Mam kilka bibliotek. W różnych miastach. Czasami przewożę książki z jednej, do drugiej. Czasami jakąś sprzedam a czasami chcę upewnić się, gdzie jest ta, której potrzebuję.\n\n### Bibliofile\n\nRzadko się zdarza, aby pasjonaci książek ich nie czytali. Tendencja jest następująca w przypadku bibliofili kolekcjonujących - 1 książka przeczytana na 10 książek kupionych. Posiadanie własnego katalogu to gratka dla każdego bibliofila.\n\nPo skatalogowaniu książek otrzymujesz:\n\n- Wgląd do stanu biblioteczki, wyszukiwanie, udostępnianie, zmienianie statusów książek.\n- Dostęp do biblioteczki z każdego miejsca na ziemi.\n- Wgląd w biblioteczki innych - odważysz się podzielić książką z innymi?\n- Dostęp do powiadomień i ustawiania automatycznych przypomnień o zwrocie\n\n### Organizacje\n\nUdostępnianie nieodpłatne utworów z prawami autorskimi, bez uiszczenia opłaty za udostępnienie jest nielegalne. Posiadanie katalogu własnych książek rozwiązuje ten problem, ponieważ istnieje jasna informacja o właścicielu książki - formalnie wiadomo do kogo należy książka. Każdy egzemplarz książki na YouTalky może posiadać tylko jednego właściciela.\n\nKatalogując książki otrzymujesz:\n\n- Wszystko to co bibliofil plus:\n- Oficjalną informację o właścicielu książki (stąd problem upubliczniania właśności znika)\n- Stronę statyczną egzemplarza, który dostępny jest w Google (rozpoznawalność w sieci rośnie, dzięki skatalogowanemu zbiorowi)\n\n___\n\n## Katalogowanie wieloosobowe\n\n### Z przyjaciółmi\n\nIstnieje wiele inicjatyw, szczególnie w mniejszych ośrodkach miejskich lub podmiejskich, które dzielą się książkami. Ludzie pożyczają sobie książki. Coś zupełnie naturalnego. Szansa pojawia się, kiedy grono rośnie i liczba pozycji też. Do Asi i Basi dołącza jeszcze 20 osób, każda ze swoją książką. Skatalogowanie przez nie swoich zbiorów powoduje, że każda z 22 osób, po wejściu na stronę główną i wyszukaniu książki, będzie mogła znaleźć każdą z tych, która należy do grupy.\n\nKatalogowanie obejmuje również śledzenie dostępności i lokalizacji. Jest więc idealnym sposobem, aby otworzyć półkę w systemie dla osiedlowej, lokalnej lub [plenerowej](https://mbddim.pl/index.php/features/podcasty/103-artykuly/307-plenerowa-biblioteczka-zapraszamy-do-dzielenia-sie-ksiazkami) na której będą skatalogowane książki. W ten sposób, każdy może sprawdzić co jest aktualnie w biblioteczce oraz kto był ostatnio w posiadaniu tytułu, który nas interesuje.\n\nZakładając konto otrzymujesz:\n\n- Sprawdzanie stanu lokalnej biblioteczki\n- Możliwość udostępnienia zasobu książek bliskiemu gronu (rodzina, koło gospodyń, Dyskusyjny Klub Książki).\n- Zostanie lokalnym bibliotekarzem i wspierania czytelnictwa w regionie.\n\n### Lokalnie\n\nStrona internetowa dzieli się z Googlem informacją o tym co jest w niej zawarte. Kiedy Basia będzie w Krakowie na osiedlu X przeszukiwać YouTalky, będzie mogła wpaść na biblioteczkę Asi z osiedla Y i napisać do niej. Może wymienią się książkami?\n\nTo rozwiązanie sprawdza się idealnie w przypadku rzadszych książek. Niekoniecznie białych kruków, bardziej książek, które mają mało amatorów. Dzięki temu, katalogując swój _niecodzienny_ zbiór, dajemy światu sygnał, że moglibyśmy porozmawiać o danej książce lub podzielić się nią / sprzedać.\n\nZakładając konto otrzymujesz:\n\n- Wgląd do biblioteczek skatalogowanych przez innych w innych miejscowościach (przybliżoną lub dokładną lokalizację).\n- Wszystkie frykasy wymienione w powyższych punktach.\n\n---\n";
const filepath = "/docs/katalogowanie-ksiazek.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
